export default {"src":"/_next/static/media/Phone-White.5a035f25.svg","height":47,"width":47};